import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "../lib/axios";
import { Button } from "@/components/ui/button";
import { API_BASE_URL } from "@/config";
import { useJourney } from "@/contexts/JourneyContext";
import JourneyHeader from "@/components/JourneyHeader";
import CallbackHelp from "@/components/CallbackHelp";

const LoanApplicationUnable = () => {
	const navigate = useNavigate();
	const { logEvent } = useJourney();

	const [isCallbackOpen, setIsCallbackOpen] = useState(false);
	const [failMsg, setFailMsg] = useState('');

	// HARD-CODED CONTROL FLAG
	const SHOW_REVIEW_DETAILS = true;

	useEffect(() => {
		logEvent({
			event: 'terminal_rejection_viewed'
		});
	}, [logEvent]);

	useEffect(() => {
		axios
			.post(`${API_BASE_URL}/api/loan_fail_reason/`, {})
			.then(res => setFailMsg(res.data.message || ''))
			.catch(() => setFailMsg('Unable to fetch failure reason.'));
	}, []);

	return (
		<div className="min-h-screen bg-intellend-white flex flex-col">
			<JourneyHeader />

			<main className="px-3 py-3 flex-1 flex flex-col justify-center max-w-md mx-auto w-full">
				<div className="bg-white shadow-md rounded-lg p-4 mb-auto mt-auto">
					<div className="text-center py-6">
						<div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
							<p className="text-red-600 font-semibold text-lg">
								Sorry! We are unable to proceed with your loan application at the moment
							</p>
							<p
								className="msg-fail-reason text-sm text-gray-700"
								dangerouslySetInnerHTML={{ __html: failMsg }}
							/>
						</div>

						<p className="text-gray-600 mb-6">
							We apologize for any inconvenience. Our team can assist you with alternative options.
						</p>

						<div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
							<Button
								type="button"
								variant="outline"
								onClick={() => setIsCallbackOpen(true)}
								className="w-full sm:w-auto"
							>
								Request Callback
							</Button>

							{SHOW_REVIEW_DETAILS ? (
								<Button
									className="w-full sm:w-auto bg-intellend-green hover:bg-intellend-green/90"
									onClick={async () => {
										try {
											await logEvent({
												stage: 'PERSONAL_INFO',
												advance: true,
												allow_rewind: true,
												route: '/personal-info'
											});
											navigate('/personal-info');
										} catch (error) {
											console.error('Failed to reset journey:', error);
											navigate('/personal-info');
										}
									}}
								>
									Review Details
								</Button>
							) : (
								<Button
									className="w-full sm:w-auto bg-intellend-green hover:bg-intellend-green/90"
									onClick={() => navigate('/')}
								>
									Exit to Home
								</Button>
							)}
						</div>
					</div>
				</div>
			</main>

			<CallbackHelp
				isOpen={isCallbackOpen}
				setIsOpen={setIsCallbackOpen}
				showOk={false}
				showCallUs={true}
				showWhatsappUs={true}
				silentlyTrigger={true}
				title="Intellend Support"
			/>
		</div>
	);
};


export default LoanApplicationUnable;
